import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import { CardButton, CardLightButton } from "../../components/common";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

const SignupBottom = ({
  onPressBack,
  onPressNext,
  noLeftButton,
  isRightButtonLocked,
  isRequesting,
  rightButtonText,
  testID,
}) => {
  return (
    <View style={styles.main}>
      <CardLightButton
        text={i18n.t("signup-previous-button")}
        onPress={onPressBack}
        isDisabled={noLeftButton}
        textPropStyle={{
          color: theme.colors["neutral.400"],
          opacity: noLeftButton ? 0 : 1,
          fontWeight: "normal",
        }}
        buttonPropStyle={{
          height: 50,
          borderColor: theme.colors["neutral.400"],
          width: width / 2 - 30,
          opacity: noLeftButton ? 0 : 1,
          borderRadius: 25,
          backgroundColor: "white",
        }}
      />
      <CardButton
        testID={testID}
        isDisabled={isRightButtonLocked}
        requesting={isRequesting}
        text={i18n.t(rightButtonText)}
        onPress={onPressNext}
        buttonPropStyle={{
          width: width / 2 - 30,
          height: 40,
          borderRadius: 25,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingView: {
    alignItems: "center",
    justifyContent: "center",
    width: width / 2 - 30,
  },
});

SignupBottom.defaultProps = {
  title: "Inscription",
  progress: 0.1,
};

export default SignupBottom;
